export default __webpack_public_path__ + "static/media/waterInActiveIcon.0e8e8599.svg";